<div class="page-wrapper">

    <app-bees-header></app-bees-header>

    <div class="stricky-header stricked-menu main-menu">
        <div class="sticky-header__content"></div>
    </div>



    <!-- PAGE HEADER -->

    <section class="page-header">

        <div class="page-header__bg" style="background-image: url(assets/images/backgrounds/page-header-bg.jpg);">
        </div>

        <div class="container">
            <div class="page-header__inner">
                <div class="page-header__img-1"> <img src="assets/images/resources/page-header-img-1.png" alt=""> </div>
                <div class="page-header__shape-1 float-bob-y"> <img src="assets/images/shapes/page-header-shape-1.png"
                        alt=""> </div>
                <h3>Products</h3>
                <div class="thm-breadcrumb__inner">
                    <ul class="thm-breadcrumb list-unstyled">
                        <li> <a href="index.html">Home</a> </li>
                        <li> <span class="fas fa-angle-right"></span> </li>
                        <li> <a href="services.html">Products</a> </li>
                        <li> <span class="fas fa-angle-right"></span> </li>
                        <li>Products</li>
                    </ul>
                </div>
            </div>

        </div>

    </section>



    <!-- SERVICE DETAILS -->

    <section class="service-details">

        <div class="container">
            <div class="row">
                <!-- SIDEBAR -->
                <div class="col-xl-4 col-lg-5">
                    <div class="service-details__sidebar">
                        <div class="service-details__services-box">
                            <h3 class="service-details__services-title"> Products </h3>
                            <ul class="service-details__services-list list-unstyled">


                                <li [class.active]="activeSection === 'salt'">
                                    <a (click)="goToSection('salt')">
                                        Salt
                                        <span class="icon-next"></span>
                                    </a>
                                </li>


                                <li [class.active]="activeSection === 'tea'">
                                    <a (click)="goToSection('tea')">
                                        Tea
                                        <span class="icon-next"></span>
                                    </a>
                                </li>


                                <li [class.active]="activeSection === 'coffee'">
                                    <a (click)="goToSection('coffee')">
                                        Coffee
                                        <span class="icon-next"></span>
                                    </a>
                                </li>


                                <li [class.active]="activeSection === 'chilipowder'">
                                    <a (click)="goToSection('chilipowder')">
                                        Chili Powder
                                        <span class="icon-next"></span>
                                    </a>
                                </li>


                                <li [class.active]="activeSection === 'dryredchili'">
                                    <a (click)="goToSection('dryredchili')">
                                        Dry Red Chili
                                        <span class="icon-next"></span>
                                    </a>
                                </li>


                                <li [class.active]="activeSection === 'kanthari'">
                                    <a (click)="goToSection('kanthari')">
                                        Kanthari Chili
                                        <span class="icon-next"></span>
                                    </a>
                                </li>


                                <li [class.active]="activeSection === 'coir'">
                                    <a (click)="goToSection('coir')">
                                        Coir Products
                                        <span class="icon-next"></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                           <div class="service-details__sidebar-contact">

                            <div class="service-details__sidebar-contact-img">

                                <div class="inner">
                                    <img src="assets/images/services/service-details-sidebar-img.png" alt="">
                                </div>

                            </div>

                            <div class="service-details__sidebar-contact-content">

                                <div class="icon">
                                    <span class="icon-phone-call"></span>
                                </div>

                                <h2>
                                    <a href="tel:919447117399">

                                        +91 944 7117 399
                                    </a>
                                </h2>

                                <h2 style="color:#fd5523;">
                                    If You Need Any Help
                                    <br>
                                    Contact With Us
                                </h2>

                            </div>

                        </div>
                    </div>
                </div>


                <!-- RIGHT CONTENT -->
                <div class="col-xl-8 col-lg-7">
                    <div class="service-details__left">


                        <!-- SALT -->
                        <div *ngIf="activeSection === 'salt'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-12.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> Salt </h3>
                            <p class="service-details__text-1">
                                Salt is an inevitable mineral item used for seasoning, food preservation and regulating
                                body fluids, containing sodium and chloride. It is crucial for nerve function and muscle
                                relaxation but excessive intake leads to high blood pressure, heart disease and stroke.
                                It is available in refined iodised table salt in 1 and 2 kg sealed packets.
                            </p>
                        </div>


                        <!-- TEA -->
                        <div *ngIf="activeSection === 'tea'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-13.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> Tea </h3>
                            <p class="service-details__text-1">
                                Tea is an aromatic beverage prepared by steeping cured leaves of the plant in hot water,
                                which is the world’s second most popular drink. It is available in black, green,oolong
                                and white, highly prized for its flavours and antioxidant properties, in sealed packets
                                of 100,200,250,500,1000 grams. </p>
                        </div>


                        <!-- COFFEE -->
                        <div *ngIf="activeSection === 'coffee'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-14.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> Coffee </h3>
                            <p class="service-details__text-1">
                                Coffee is a brewed beverage prepared from roasted seeds of coffee plant globally popular
                                for its stimulating caffeine content and complex flavour profiles. Coffee consumption is
                                often associated with health benefits including lower risks of heart disease, diabetes
                                and stroke. It is available as powder in packets of 100, 200,250,500,1000 grams.

                            </p>
                        </div>


                        <!-- CHILI POWDER -->
                        <div *ngIf="activeSection === 'chilipowder'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-15.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> Chili Powder </h3>
                            <p class="service-details__text-1">
                                Chili powder is the dried, pulverised fruit of one or more varieties of chili pepper,
                                commonly used in tex- mex dishes, stews and sauces, available in sealed packets of
                                100,200,250,500,1000 grams
                            </p>
                        </div>


                        <!-- DRY RED CHILI -->
                        <div *ngIf="activeSection === 'dryredchili'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-16.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> Dry Red Chili </h3>
                            <p class="service-details__text-1">
                                Dry red chillies are sun- dried or dehydrated peppers, essential for adding heat,
                                flavour and vibrant color to cuisines, nutrient rich and long lasting pungent or mild
                                flavouring for tempering and spice blends, available in. Sealed packets of 100,
                                200,250,500,1000 grams.
                            </p>
                        </div>


                        <!-- KANTHARI -->
                        <div *ngIf="activeSection === 'kanthari'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-17.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> Kanthari Chili </h3>
                            <p class="service-details__text-1">
                                Kant Hari chili or bird’s eye chili are used in curries and other foods, have medicinal
                                properties- a number of health advantages including lowering blood pressure, cholesterol
                                and other cardiac conditions, available in sealed packets of 100, 200, grams.
                            </p>
                        </div>


                        <!-- COIR -->
                        <div *ngIf="activeSection === 'coir'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-18.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> Coir Products </h3>
                            <p class="service-details__text-1">
                                Coir - art worked foot mat, long mat, carpets, coloured coir products etc. available in
                                prescribed packages.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </section>



    <app-bees-footer></app-bees-footer>

</div>


<div class="lock-popup"
     *ngIf="showPopup">

    <div class="popup-box">

        <h3>

            Enter Access Code

        </h3>

        <div class="pin-box">

            <input #p1
                   maxlength="1"
                   [(ngModel)]="pin1"
                   (input)="moveNext($event,p2)">

            <input #p2
                   maxlength="1"
                   [(ngModel)]="pin2"
                   (input)="moveNext($event,p3)">

            <input #p3
                   maxlength="1"
                   [(ngModel)]="pin3"
                   (input)="moveNext($event,p4)">

            <input #p4
                   maxlength="1"
                   [(ngModel)]="pin4"
                   (input)="moveNext($event)">

        </div>

        <p class="error"
           *ngIf="errorMsg">

            {{errorMsg}}

        </p>

    </div>

</div>

<div *ngIf="!showPopup">

    <!-- EXISTING PAGE -->

</div>